module.exports = __webpack_public_path__ + "img/custom_embroidery.4f26b7aa.jpeg";